import customAxios from "../serverCall";

const getAllPosts = async (body) => {
  const response = await customAxios.post(`/admin/posts`, body);
  return response;
};
const updateBatchType = async (body) => {
  const response = await customAxios.post(`/admin/verificationbadge`, body);
  return response;
};

const deletePost = async (body) => {
  const response = await customAxios.post(`/admin/posts/delete`, body);
  return response;
};

const PostService = {
  getAllPosts,
  updateBatchType,
  deletePost
};

export default PostService;
